import React from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";
import { navLinks, profile } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#14203a] text-white/80">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <h3 className="font-serif text-2xl font-bold text-white">
              T.P. Sreenivasan
            </h3>
            <div className="w-12 h-[3px] bg-[#b8935a] my-4" />
            <p className="text-sm leading-relaxed text-white/60 max-w-xs">
              Former Ambassador & Permanent Representative of India to the United
              Nations, Vienna. A life devoted to diplomacy, writing and public
              service.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-[#b8935a] mb-5">
              Explore
            </h4>
            <ul className="grid grid-cols-2 gap-y-3 gap-x-4">
              {navLinks.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    className="text-sm text-white/70 hover:text-white transition-colors duration-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-[#b8935a] mb-5">
              Get in Touch
            </h4>
            <a
              href={`mailto:${profile.email}`}
              className="inline-flex items-center gap-2 text-sm text-white/80 hover:text-[#e6c98d] transition-colors duration-300 group"
            >
              <Mail size={16} />
              {profile.email}
              <ArrowUpRight
                size={14}
                className="opacity-0 group-hover:opacity-100 transition-opacity"
              />
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} T.P. Sreenivasan. All rights reserved.
          </p>
          <p className="text-xs text-white/40">
            A modern tribute site · Content is representative
          </p>
        </div>
      </div>
    </footer>
  );
}
